export default function rpPayerDDOptions(data: any) {
  return data.map((dataObj: any) => {
    return {
      label: `${dataObj.payer_data.payer_name} | ${dataObj.payer_data.payer_tin_type}: ${dataObj.payer_data.payer_tin}`,
      value: dataObj.payer_data.payer_id,
    };
  });
}
